import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  role?: string;
  company?: string;
  initial: string;
}
export function TestimonialCard({
  quote,
  author,
  role,
  company,
  initial
}: TestimonialCardProps) {
  return <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 relative" data-id="element-147">
      <Quote className="absolute top-6 right-6 w-8 h-8 text-slate-200" data-id="element-148" />
      <div className="mb-6 relative z-10" data-id="element-149">
        <p className="text-slate-700 italic text-lg leading-relaxed" data-id="element-150">
          "{quote}"
        </p>
      </div>
      <div className="flex items-center" data-id="element-151">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold mr-3 border border-blue-200" data-id="element-152">
          {initial}
        </div>
        <div data-id="element-153">
          <div className="font-bold text-slate-900" data-id="element-154">{author}</div>
          {(role || company) && <div className="text-sm text-slate-500" data-id="element-155">
              {role && <span data-id="element-156">{role}</span>}
              {role && company && <span data-id="element-157"> • </span>}
              {company && <span data-id="element-158">{company}</span>}
            </div>}
        </div>
      </div>
    </div>;
}